import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class CadastroProvider {
  baseUrl = environment.API_URL;
  baseAntigaUrl = environment.API_ANTIGA_URL;

  constructor(public http: HttpClient) {}

  buscarCampos(idInstituicao, tipo, idPessoa, idPessoaTipo, idPessoaAtual) {
    return this.http
      .post<any>(this.baseUrl + '/cadastro/buscar-campos', {
        tipo: tipo,
        idInstituicao: idInstituicao,
        idPessoa: idPessoa,
        idPessoaTipo: idPessoaTipo,
        idPessoaAtual: idPessoaAtual,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  salvarCadastroInicial(pessoa, facebook) {
    return this.http
      .post<any>(this.baseUrl + '/cadastro/salvar-cadastro', {
        pessoa: pessoa,
        facebook: facebook,
      })
      .map((data) => {
        return data;
      });
  }

  salvarCadastro(pessoa) {
    return this.http
      .post<any>(this.baseUrl + '/cadastro-form/salvar-cadastro', {
        pessoa: pessoa,
      })
      .map((resposta) => {
        return resposta;
      });
  }

  addProfissao(profissao, idInstituicao) {
    return this.http
      .post<any>(this.baseUrl + '/cadastro/add-profissao', {
        profissao: profissao,
        idInstituicao: idInstituicao
      })
      .map((data) => {
        if (!data.error) {
          return data;
        }
        return false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/cadastro/cadastro.ts